<template>
    <div v-if="show" class="modal">
        <div class="modal-content max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <span class="close" @click="closeModal">&times;</span>
            <div class="lg:px-8">
                <div class="pb-4 w-full">
                    <h2 class="page-title">Рибалка на озері {{ selectedPoint.lake_name }}</h2>
                    <h3 class="page-subtitle mt-2">{{ selectedPoint.name }}</h3>
                </div>
                <div class="pb-8 w-full">
                    <p>Дата: {{ form.date[0] }}</p>
                </div>
                <div class="pb-8 w-full">
                    <p>Ціна: {{ price }} грн</p>
                </div>
                <div class="mb-4" v-if="selectedPoint.attributes.length">
                    Додатково:
                    <ul class="mt-2">
                        <li class="flex items-center mb-1" v-for="attribute in selectedPoint.attributes">
                            <input
                                class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                :checked="!attribute.optional"
                                :disabled="!attribute.optional"
                                type="checkbox"
                                :id="'checkbox-' + attribute.id"
                                v-model="attribute.checked"
                                @click="selectAttribute(attribute.id)"
                            >
                            <label :for="'checkbox-' + attribute.id">
                                {{ attribute.title }} - {{ attribute.price }} грн
                            </label>
                        </li>
                    </ul>
                </div>
                <select-input
                    v-model="form.typeId"
                    :error="form.errors.typeId"
                    class="pb-8 w-full lg:w-1/2 lg:pr-6"
                    label="Тип рибалки"
                >
                    <option v-for="type in types" :key="type.id" :value="type.id">
                        {{ type.name }} ({{ type.description }})
                    </option>
                </select-input>
                <select-input
                    v-model="form.categoryId"
                    :error="form.errors.categoryId"
                    class="pb-8 w-full lg:w-1/2 lg:pr-6"
                    label="Вид рибалки"
                >
                    <option v-for="category in categories" :key="category.id" :value="category.id">
                        {{ category.name }}
                    </option>
                </select-input>
                <text-input
                    v-if="isQuantityAvailable"
                    v-model="form.quantity"
                    :error="form.errors.quantity"
                    class="pb-8 w-full lg:w-1/4"
                    type="number"
                    min="1"
                    label="Кількість людей"
                />
                <div class="modal-booking-btn-wrapper">
                    <button
                        class="btn-indigo btn-booking modal-booking-btn lg:mr-6"
                        :disabled="disabled"
                        @click.prevent="addToCart"
                    >
                        Зберегти і продовжити покупки
                    </button>
                    <button
                        class="btn-indigo btn-booking modal-booking-btn"
                        :disabled="disabled"
                        @click.prevent="addThenLinkToCart"
                    >
                        Забронювати та перейти до оплати
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SelectInput from "@/Shared/SelectInput"
import DatePicker from "@/Shared/DatePicker"
import LoadingButton from "@/Shared/LoadingButton"
import TextInput from "@/Shared/TextInput"
import {useToast} from 'vue-toastify'
import messages from "@/Constants/messages"
import axios from "axios";

export default {
    name: "PointsBookingModal",
    components: {TextInput, LoadingButton, DatePicker, SelectInput},
    props: {
        isQuantityAvailable: {
            type: Boolean,
            default: true
        },
        selectedPoint: Object,
        show: Boolean,
        types: Object || Array,
        categories: Array,
        date: Array,
        defaultPrice: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            disabled: false,
            form: this.$inertia.form({
                quantity: this.isQuantityAvailable ? 1: 0,
                lakeId: this.selectedPoint.lake_id,
                date: this.date,
                typeId: this.types[0] ? this.types[0].id : null,
                categoryId: this.categories[0] ? this.categories[0].id : null,
                pointId: this.selectedPoint.id,
                attributesIds: []
            }),
            toast: null,
            cartCount: 0,
            price: this.defaultPrice
        }
    },
    watch: {
        form: {
            handler: function () {
                this.fetchPriceDays();
            },
            deep: true
        },
        selectedPoint: {
            handler: function (newVal) {
                this.updateFormFields(newVal);
            },
            deep: true
        },
        date(newValue) {
            this.form.date = newValue
        },
        types(newValue) {
            this.form.typeId = newValue[0] ? newValue[0].id : null
        }
    },
    methods: {
        updateFormFields(point) {
            this.form.lakeId = point.lake_id
            this.form.pointId = point.id
            this.fetchPriceDays()
        },
        closeModal() {
            this.$emit('update:show', false)
            this.form.reset({
                preserve: ['date']
            })
        },
        addToCart() {
            this.disabled = true
            this.form.post(this.$route('cart.add.without.redirect', this.form.pointId), {
                preserveScroll: true,
                onSuccess: (page) => {
                    if (page.props.cartCount) {
                        this.$emit('updateCartCount', page.props.cartCount);
                    }
                    this.closeModal()
                    this.showToast()
                    this.disabled = false
                },
            });
        },
        showToast() {
            this.toast.success(messages.successAddedToCart);
        },
        async addThenLinkToCart() {
            this.disabled = true
            this.form.post(this.$route('cart.add.with.redirect', this.form.pointId), {
                preserveScroll: true,
                onSuccess: (page) => {
                    if (page.props.cartCount) {
                        this.$emit('updateCartCount', page.props.cartCount);
                    }
                    this.closeModal()
                    this.showToast()
                    this.disabled = false
                },
            });
        },
        fetchPriceDays() {
            if (this.selectedPoint.id) {
                axios.get(`/current-price/${this.selectedPoint.id}`, {
                    params: {
                        quantity: this.form.quantity,
                        lakeId: this.form.lakeId,
                        date: this.form.date,
                        typeId: this.form.typeId,
                        categoryId: this.form.categoryId,
                        pointId: this.form.pointId,
                        attributesIds: this.form.attributesIds,
                    }
                })
                    .then(response => {
                        this.price = response.data.price;
                    })
                    .catch(error => {
                        console.error('Error fetching price:', error);
                    });
            }
        },
        selectAttribute(id) {
            const index = this.form.attributesIds.indexOf(id)
            if (index !== -1) {
                this.form.attributesIds.splice(index, 1)
            } else {
                this.form.attributesIds.push(id)
            }
            this.fetchPriceDays()
        }
    },
    mounted() {
        this.toast = useToast()
        if (this.selectedPoint) {
            this.updateFormFields(this.selectedPoint);
        }
        if (this.types.length > 0) {
            this.form.typeId = this.types[0].id;
        }
        if (this.categories.length > 0) {
            this.form.categoryId = this.categories[0].id;
        }
    }

}
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
